import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=1392e50a"
import script from "./Appointment.js?vue&type=script&lang=js&external"
export * from "./Appointment.js?vue&type=script&lang=js&external"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=1392e50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports